<template>
  <section class="app-sidebar" >
    <nav class="sidebar sidebar-offcanvas" id="sidebar" style="z-index: 1001;">
      <ul class="nav">
        <li class="nav-item" v-on:click="collapseAll">
          <router-link class="nav-link" to="/">
            <i class="ti-home menu-icon"></i>
            <span class="menu-title">Dashboard</span>
          </router-link>
        </li>
        <li class="nav-item cursor-pointer">
          <span class="nav-link" v-b-toggle="'sites'">
            <i class="menu-icon"><font-awesome-icon icon="building"/></i>
            <span class="menu-title">Sites</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse accordion="sidebar-accordion" id="sites">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <router-link class="nav-link" to="/sites">PoP Sites</router-link>
              </li>
              <li class="nav-item" v-if="sitesLoaded">
                <a class="nav-link" @click="getUserCheckins()">Site Check-In</a>
                <siteCheckinModal modalID="siteCheckinModal" :checkedInSite ="checkoutsActive ? getSite(checkoutList[0].siteid) : null"/>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item cursor-pointer">
          <span class="nav-link" v-b-toggle="'equipment'">
            <i class="menu-icon"><font-awesome-icon icon="server"/></i>
            <span class="menu-title">Equipment</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse accordion="sidebar-accordion" id="equipment">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <router-link class="nav-link" to="/equipment/inventory">Spare Parts Inventory</router-link>
              </li>           
              <li class="nav-item">
                <router-link class="nav-link" to="/equipment">Equipment</router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item">
            <router-link class="nav-link" to="/tickets"> 
                <i class="menu-icon fa fa-ticket"></i>
                <span class="menu-title">Tickets</span>         
            </router-link>
        </li>
        <li class="nav-item" v-on:click="collapseAll" >
          <router-link class="nav-link" to="/general-pages/customer-faq">
            <i class="menu-icon"><font-awesome-icon icon="building"/></i>
            <span class="menu-title">FAQ & Knowledge Base</span>          
          </router-link>
        </li>
        <li class="nav-item cursor-pointer">
          <span class="nav-link" v-b-toggle="'admin'">
            <i class="ti-clipboard menu-icon"></i>
            <span class="menu-title">Administration</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse accordion="sidebar-accordion" id="admin">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <router-link class="nav-link" to="/users">Users</router-link>
              </li>
              <li v-if="userprofile.companyAdmin" class="nav-item">
                <router-link class="nav-link" to="/">Company Settings</router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item cursor-pointer text-center d-flex d-md-none">
          <a :href="`tel:1300837638`" class="nav-link">
            <button type="button" class="btn btn-inverse-primary btn-fw"><i class="mx-0 mr-1">
              <font-awesome-icon icon="phone"></font-awesome-icon>
            </i> 1300 837 638
            </button>
          </a>
        </li>
      </ul>
    </nav>
  </section>
</template>

<script>
import siteCheckinModal from "@/pages/sites/components/siteCheckinModal";

export default {
  name: "sidebar",
  components: {
    siteCheckinModal
   },

  computed: {
    userprofile () {
      return this.$store.getters.getProfile;
    },
    customerprofile () {
      return this.$store.getters.getMyCustomerProfile;
    },
    sitesLoaded(){
      try {
        return this.$store.getters.isSitesListLoaded
      } catch (error) {
        return false
      }
    }
  },
  data() {
    return {
      collapses: [{ show: false }, { show: false }, { show: false }],
      items: [],
      checkoutsActive: false,
      checkoutList: []
    };
  },
  methods: {
    getSite(siteid){
        return this.$store.getters.getSite(siteid)
    },
    getUserCheckins() {
      let userCheckins = this.$store.getters.getUserCheckins(this.userprofile.userid).filter(thisCheckin => thisCheckin.checkouttime == null)
      if(userCheckins.length > 0){
        this.checkoutList = userCheckins
        this.checkoutsActive = true
      } else {
        this.checkoutList = []
        this.checkoutsActive = false
      }

      this.$bvModal.show('siteCheckinModal')
    },
    collapseAll() {
      var exp_elm = document.getElementsByClassName("show");
      if (exp_elm.length > 0) {
        var elm_id = exp_elm[0].id;
        this.$root.$emit("bv::toggle::collapse", elm_id);
      }
    },
    revealAll() {
      var exp_elm = document.getElementsByClassName("show");
      if (exp_elm.length > 0) {
        var elm_id = exp_elm[0].id;
        this.$root.$emit("bv::toggle::show", elm_id);
      }
    },
    newTicket(ticketID) {
      this.$router.push('/ticket/'+ticketID)
      this.openTicket(ticketID)
    },
  },
  mounted() {
    const body = document.querySelector("body");
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    document.querySelectorAll(".sidebar .nav-item").forEach(function(el) {
      el.addEventListener("mouseover", function() {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.add("hover-open");
        }
      });
      el.addEventListener("mouseout", function() {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.remove("hover-open");
        }
      });
    });
  },
  watch: {
    $route() {
      if(document.querySelector("#sidebar").classList.contains("active")) { document.querySelector("#sidebar").classList.toggle("active"); }
    }
  }
};
</script>
